'use client';

import { langPrefix } from '@/lib/locale-path';
import React, { useRef } from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import FeedbackDialog, { type FeedbackDialogHandle } from './FeedbackDialog';

// "Contact us" in the footer: opens the contact form over the current page, so
// nobody loses their place to write to us. It stays a real link to /contact -
// the page emails and the privacy policy point to - so a new tab, a middle
// click or a browser without JavaScript still get there.

export default function ContactUsLink({ lang, className = '' }: { lang: string; className?: string }) {
  const isFr = lang === 'fr';
  const href = `${langPrefix(lang)}/contact`;
  const pathname = usePathname();
  const dialog = useRef<FeedbackDialogHandle>(null);

  return (
    <>
      <Link
        href={href}
        className={className}
        onClick={(e) => {
          // Let the browser handle anything but a plain click, and on /contact
          // itself the form is already on the page.
          if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || pathname === href) return;
          e.preventDefault();
          dialog.current?.open();
        }}
      >
        {isFr ? 'Nous joindre' : 'Contact us'}
      </Link>
      <FeedbackDialog ref={dialog} lang={lang} kind="contact" title={isFr ? 'Nous joindre' : 'Contact us'} />
    </>
  );
}
